import { useCallback, useState } from "react";
import useSponsorFunctions from "./useSponsorFunctions.hook";
import AuspicienteModel from "../../domain/models/auspiciante.model";


const useSponsorGeneralConf = () => {
    const { getAllSponsors, createSponsor, updateSponsor, deleteSponsor } = useSponsorFunctions();
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [sponsors, setSponsors] = useState<AuspicienteModel[]>([]);

    const fetchSponsors = useCallback(async () => {
        setIsLoadingData(true);
        setSponsors(await getAllSponsors());
        setIsLoadingData(false);
    }, [getAllSponsors]);

    const createSponsorHandler = useCallback(async (sponsor: AuspicienteModel) => {
        setIsLoadingData(true);
        await createSponsor(sponsor);
        await fetchSponsors();
        setIsLoadingData(false);
    }, [createSponsor, fetchSponsors]);

    const updateSponsorHandler = useCallback(async (sponsor: AuspicienteModel) => {
        setIsLoadingData(true);
        await updateSponsor(sponsor);
        await fetchSponsors();
        setIsLoadingData(false);
    }, [updateSponsor, fetchSponsors]);

    const deleteSponsorHandler = useCallback(async (id: number) => {
        setIsLoadingData(true);
        await deleteSponsor(id);
        await fetchSponsors();
        setIsLoadingData(false);
    }, [deleteSponsor, fetchSponsors]);

    return {
        loaders: {
            isLoadingData,
        },
        data: {
            sponsors,
        },
        actions: {
            fetchSponsors,
            createSponsorHandler,
            updateSponsorHandler,
            deleteSponsorHandler,
        }
    };
}

export default useSponsorGeneralConf;